import React from 'react';

import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { AppContext } from 'src/contexts/appContext';
import { ILaunchDateProps } from 'src/types/ILaunchDates';

import './ReviewLaunchDate.scss';

export const ReviewLaunchDate = ({ onPrevious, onCancel, onSubmit, launchDateValues }: ILaunchDateProps) => {
    const { metadata } = React.useContext(AppContext);

    return (
        <>
            <Heading level={1}>Review</Heading>

            <Column spacingInset="500 none none none" spacing="400">
                <Row alignmentHorizontal="justify" alignmentVertical="top">
                    <Column spacing="400">
                        <Column spacing="200">
                            <Text tag="label" type="h100">
                                Service
                            </Text>
                            <Text>
                                {launchDateValues.serviceID !== ''
                                    ? metadata.serviceMapping[parseInt(launchDateValues.serviceID)].serviceName
                                    : ''}
                            </Text>
                        </Column>

                        <Column spacing="200">
                            <Text tag="label" type="h100">
                                Territory
                            </Text>
                            <Text>{launchDateValues.territoryCode}</Text>
                        </Column>

                        <Column spacing="200">
                            <Text tag="label" type="h100">
                                Launch Date
                            </Text>
                            <Text>{launchDateValues.launchDate}</Text>
                        </Column>
                        <Column spacing="200">
                            <Text tag="label" type="h100">
                                End date
                            </Text>
                            <Text>{launchDateValues.endDate !== '' ? launchDateValues.endDate : '--'}</Text>
                        </Column>
                    </Column>
                </Row>
            </Column>

            <Column spacingInset="500 none none none">
                <Row alignmentHorizontal="end">
                    <Button type="link" onClick={onCancel} aria-label="Cancel">
                        Cancel
                    </Button>
                    <Button type="tertiary" onClick={onPrevious} aria-label="Go to previous step">
                        Previous
                    </Button>
                    <Button type="primary" onClick={onSubmit} aria-label="Add Launch Date">
                        {launchDateValues.launchToBeDeactivated == '' ? 'Add Launch Date' : 'Confirm Edit'}
                    </Button>
                </Row>
            </Column>
        </>
    );
};
